import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MastersuiteService } from '../mastersuite.service';
import { AuthenticationService, CommonService } from '@app/_services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { constants } from '@assets/data/constants';
@Component({
  selector: "app-mastersuite-associate",
  templateUrl: "./mastersuite-associate.component.html",
  styleUrls: ["./mastersuite-associate.component.less"],
})

export class MastersuiteAssociateComponent implements OnInit {

  moduleDetails: any = {};
  moduleType;
  jiraDefect: any = {};

  constructor(private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    public mastersuiteservice: MastersuiteService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _commonServices: CommonService) { }

  mastersuiteDetails = {};
  newMasterSuiteForm: FormGroup;
  testSuiteSearchForm: FormGroup;
  myProjectsList = [];
  testSuiteList = [];
  assocTestSuites = [];
  page = 1;
  pageSize = 15;
  collectionSize: any;
  isMSEdit = false;
  masterSuiteId = null;
  showSrch = false;
  constants = constants;
  submitted: boolean = false;

  ngOnInit() {
    this.setForm();
    this.setTestSuiteSearchForm();
    this.myProjects()
    this.loadTestSuites();
    this.route.params.subscribe(() => {
      this.moduleType = this.route.snapshot.data['type'];
      this.moduleDetails = this.route.snapshot.data['details'].response;

    });
    if (this.route.snapshot.routeConfig.path === ':id/associate') {
      this.isMSEdit = true;
      this.masterSuiteId = parseInt(this.route.snapshot.paramMap.get('id'));
      this.getAssocTestSuites(parseInt(this.masterSuiteId));
      this.getMastersuiteDetails(parseInt(this.masterSuiteId));
    } else {
      this.titleService.setTitle('MS | new');
    }
  }

  getMastersuiteDetails(id) {
    this.mastersuiteservice.getMastersuiteById(id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.mastersuiteDetails = data.response;
        this.titleService.setTitle('MS | '+ this.mastersuiteDetails['name'] + ' | edit');
        this.newMasterSuiteForm.patchValue(data.response);
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  setForm() {
    this.newMasterSuiteForm = this.formBuilder.group({
      id: [null],
      active: [null],
      name: ['', Validators.required],
      project: [null, Validators.required],
      description: [''],
      parallelRun: [true],
    });
  }

  /* Search form */
  setTestSuiteSearchForm() {
    this.testSuiteSearchForm = this.formBuilder.group({
      keyword: [null],
      projectIds: [null],
    });
  }

  myProjects() {
    this._commonServices.getMyProjects().pipe().subscribe(data => {
      this.myProjectsList = data.response;
      if(localStorage.getItem("defaultUserConfig") !== null && JSON.parse(localStorage.getItem("defaultUserConfig")).default_project && this.route.snapshot.routeConfig.path !== ':id/edit') {
        this.setDefaultProject(JSON.parse(localStorage.getItem("defaultUserConfig")).default_project);
      }
    });
  }

  setDefaultProject(projectId: any) {
    var selectedProject = this.myProjectsList.find((element) => {
      if(element.id === projectId) return element;
    });
  }

  loadTestSuites() {
    const searchParams = this.testSuiteSearchForm.value || null;
    const collection = {
      page: this.page || 0,
      size: this.pageSize || 15
    };
    const overallData = { ...searchParams, ...collection };
    this.mastersuiteservice.getTestSuiteList(overallData).subscribe((data: any) => {
      if (data.code === 200) {
        this.collectionSize = data.response.count;
        this.testSuiteList = data.response.testSuites;
      } else {
        this.collectionSize = 0;
        this.testSuiteList = [];
      }
    });
  }

  getAssocTestSuites(id: number): void {
    this.mastersuiteservice.getAssociateShortData(id).pipe().subscribe((data: any) => {
      if (data.code === 200) {
        this.assocTestSuites = data.response;
      }
    });
  }

  removeAssocTestSuite(item) {
    const index = this.assocTestSuites.indexOf(item);
    if (index > -1) {
      this.assocTestSuites.splice(index, 1);
    }
  }

  addToAssocTestSuite(item) {
    const obj = {
      'certified': false,
      'delay': null,
      'id': null,
      'masterSuiteName': null,
      'reTry': null,
      'sequenceNumber': this.assocTestSuites.length + 1,
      'testSuiteId': item.id,
      'testSuiteName': item.name,
      'active':	true
    }
    if (!this.assocTestSuites.some((prevItem) => prevItem.testSuiteId === obj.testSuiteId)) {
      this.assocTestSuites.push(obj);
    } else {
      this.toastr.error('Testsuite is already added !!!');
    }

  }

  saveEditMasterSuite() {
    if(this.assocTestSuites.length >= 1){
      this.submitted = true;
      this.newMasterSuiteForm.value.active = true;
      delete this.newMasterSuiteForm.value.project.name;
      if (this.masterSuiteId) {
        this.newMasterSuiteForm.value.id = this.masterSuiteId;
        this.editMasterSuite(this.newMasterSuiteForm.value);
      } 
    }else{
      this.toastr.error('Please select atleast one test suite to continue');
    }
  }

  editMasterSuite(formData) {
    this.mastersuiteservice.updateMasterSuite(formData).pipe().subscribe(data => {
      if (data.code === 200) {
        this.mastersuiteservice.assocDissocTestSuite(this.masterSuiteId, this.assocTestSuites).pipe().subscribe(newData => {
          if (newData.code === 200) {
            this.toastr.success(data.message);
          }
        });
        this.router.navigateByUrl('/mastersuite/' + formData.id);
      } else {
        this.toastr.error(data.message);
      }
    });
  }


  onPageChange(page) {
    this.page = page;
    this.loadTestSuites();
  }

  onSizeChange() {
    this.loadTestSuites();
  }

  clearFilter() {
    this.setTestSuiteSearchForm();
    this.loadTestSuites();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.assocTestSuites, event.previousIndex, event.currentIndex);
  }

  isAssociated(id: number) {
    let found = false;
    for (let index = 0; index < this.assocTestSuites.length; index++) {
      const elem = this.assocTestSuites[index];
      if (elem.testSuiteId === id) {
        found = true;
      }
    }
    return found;
  }

}